import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";
import { notifyError, notifySuccess } from "src/components/Common/Toast";
import { passwordInit } from "src/service/papi";
import { useTranslation } from "react-i18next";

interface IUseLogInProps {
  setStateInit: () => void;
}
export function usePasswordInit({ setStateInit }: IUseLogInProps) {
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { t } = useTranslation();
  const { isLoading, mutate: mutatePasswordInit } = useMutation(
    "passwordInit",
    passwordInit,
    {
      onSuccess: (res) => {
        notifySuccess(t("logIn.resetPassowrd.confirmAlert"));

        setStateInit();
      },
      // useApiError의 toast.error는 ToastContainer가 없어 표시되지 않으므로 직접 노출
      onError: (err: any) => {
        notifyError(err?.response?.data?.errorMessage ?? "error");
      },
    }
  );

  return { isLoading, mutatePasswordInit };
}
